import { render, staticRenderFns } from "./MedsResultsTable.vue?vue&type=template&id=a2ab1d00&scoped=true&"
import script from "./MedsResultsTable.vue?vue&type=script&lang=js&"
export * from "./MedsResultsTable.vue?vue&type=script&lang=js&"
import style0 from "./MedsResultsTable.vue?vue&type=style&index=0&id=a2ab1d00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ab1d00",
  null
  
)

export default component.exports